module.exports = __webpack_public_path__ + "static/car-pc/img/dingding.cb5ab588.svg";